import type { RouteObject } from 'react-router';
import { PaginaInicio } from './paginas/PaginaInicio';

/**
 * `index: true` e não `path: '/'`: a rota pai já é `/` (ver `app/roteador.tsx`), e repetir o caminho
 * aqui faria o react-router tratar como rota irmã, nunca como a tela padrão da casca.
 */
export const rotas: RouteObject[] = [{ index: true, element: <PaginaInicio /> }];
